export function isURLValid(str: string) {
    const re = /^https?:\/\/.+\..+/i;
    return str.match(re);
}
